export const EUsersAction = {
  SET_USERS: 'SET_USERS',
  SET_SELECTED_USER: 'SET_SELECTED_USER',
  SET_PAGINATION: 'SET_PAGINATION_USERS',
  SET_SEARCH_PARAMS: 'SET_SEARCH_PARAMS',
};
